// extracted by mini-css-extract-plugin
export default {"subtitle":"_x_br4"};